import React from "react";
import { object, number } from "prop-types";

import StoryHeader from "../story-header";
import Tags from "../story-elements/tags";
import StorySideBar from "../story-sidebar";
import PanchangaView from "../story-elements/panchanga";

import "./panchanga-story.m.css";
import { WithLazy } from "@quintype/components";
import LatestNews from "../story-elements/latest-news";
import useDevice from "../../helper/custom-hook/useDevice";

const PanchangaStoryTemplate = ({ story, index }) => {
  const isMobile = useDevice();
  return (
    <div styleName="story-wrapper">
      <div className="story-section">
        <div>
          <StoryHeader story={story} />
          <PanchangaView story={story} />
          <Tags story={story} />
        </div>
      </div>
      {isMobile ? (
        <div>
          <WithLazy margin="300px">{() => <LatestNews story={story} />}</WithLazy>
        </div>
      ) : (
        <div>
          <StorySideBar index={index} story={story} />
        </div>
      )}
    </div>
  );
};

PanchangaStoryTemplate.propTypes = {
  story: object,
  index: number
};

const PanchangaStory = (props) => {
  return <PanchangaStoryTemplate story={props.story} index={props.index} />;
};

PanchangaStory.propTypes = {
  story: object,
  index: number
};

export default PanchangaStory;
